import { localeFormatDefault } from '@/plugins/date-print';
import User from './user';
import { EVENT_USER_STATUS } from '@/modules/Events/constants';

export default class ParticipantExpeled extends User {
  constructor(item, url) {
    super(item, url);

    this.id = item.id;
    this.avatar = item.avatar;
    this.user_id = item.user_id;
    this.username = item.user_name;
    this.full_name = item.full_name;

    this.event_id = item.event_id;
    this.group_id = item.group_id;
    this.nomination_id = item.nomination_id;
    this.reason = item.reason || '';
    this.delete_at = localeFormatDefault(item.delete_at);
    this.name = item.full_name;
    this.is_deleted = true;
    this.status = {
      id: EVENT_USER_STATUS.STATUS_DELETED,
      text: 'Исключён',
      icon: '$ui-delete',
      attrs: {
        color: 'ui-error',
        get textColor() {
          return `${this.color}--text`;
        },
        get backgroundColor() {
          return `${this.color} lighten-4`;
        },
      },
    };
  }
}
